import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { ModalComponent } from "@app/shared/components";

@Component({
    selector: 'app-password-confirm-modal',
    templateUrl: './password-confirm-modal.component.html',
    styleUrls: ['./password-confirm-modal.component.scss']
})
export class PasswordConfirmModalComponent implements OnInit {
    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;

    @Input() userIdentity: string;

    @Output() passwordConfirmed = new EventEmitter<any>();

    passwordMatch = true;
    setPasswordForm: UntypedFormGroup;

    showValidations = false;

    constructor(private formBuilder: UntypedFormBuilder) {
    }

    ngOnInit() {

        this.setPasswordForm = this.formBuilder.group({
            'password': ['', Validators.required],
            'passwordConfirmation': ['', Validators.required]
        });
    }

    open() {
        this.modal.open();
    }

    close() {
        this.modal.close();
    }

    onConfirmChangePassword() {
        if ((!this.validatePasswordMatch() && !this.setPasswordForm.valid)
            || !this.setPasswordForm.valid
            || !this.validatePasswordMatch()) {
            this.showValidations = true;
            return;
        }
        this.showValidations = false;

        const formData = Object.assign(
            {},
            this.setPasswordForm.value
        );
        formData.identity = this.userIdentity;

        this.passwordConfirmed.emit(formData);
    }

    private validatePasswordMatch() {
        const password = this.setPasswordForm.value.password;
        const confirmPassword = this.setPasswordForm.value.passwordConfirmation;

        if (password !== confirmPassword) {
            this.passwordMatch = false;
            this.setPasswordForm.reset();
            return;
        } else {
            return true;
        }
    }

}
